/* Easy creates the tax-exempt draft. The theme only selects the correct flow
   and displays its price; a DOM change never grants a tax exemption. */
(() => {
  if (window.apB2BCartBound) return;
  window.apB2BCartBound = true;
  const eu = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PT RO SK SI ES SE'.split(' '));
  let contextElement, original, busy = false, forwarding = false, scheduled = false;
  const renderedValues = new WeakMap();
  const byId = id => document.getElementById(id);
  const message = document.documentElement.lang.startsWith('pl')
    ? 'Nie udało się potwierdzić kwoty bez VAT. Odśwież koszyk i ponownie zweryfikuj numer VAT.'
    : 'The VAT-exempt total could not be confirmed. Refresh the cart and validate your VAT number again.';
  function state() {
    const element = byId('ap-cart-tax-context');
    if (!element) return null;
    const context = JSON.parse(element.textContent);
    const button = byId('ap-b2b-checkout');
    if (!button || !byId('checkout-btn')) return null;
    if (element !== contextElement) {
      contextElement = element;
      original = {};
      ['cc-netto-val', 'cc-vat-val', 'cc-total-val'].forEach(id => { original[id] = byId(id)?.innerHTML || ''; });
      original.taxLabel = byId('cc-vat-val')?.previousElementSibling?.textContent;
    }
    const company = document.querySelector('input[name="attributes[Customer Type]"]:checked')?.value === 'Firma';
    const eligible = company && eu.has(context.country) && context.rate > 0;
    const validation = byId('tax-persistent-validation')?.dataset.validationHash || '';
    const vatCountry = validation.split('|')[1]?.slice(0, 2).toUpperCase();
    const validated = !!validation && eu.has(vatCountry === 'EL' ? 'GR' : vatCountry);
    const appReady = button.dataset.b2bEnabled === 'true' && button.dataset.b2bExemptionReason === 'vat_id';
    const cents = Math.round(Number(button.dataset.b2bPrice) * 100);
    // Shopify draft pricing rounds each unit; the cart tax breakdown rounds lines.
    // Their difference is bounded by half a minor unit per item, rounded up.
    const roundingTolerance = Math.max(1, Math.ceil((Number(context.itemCount) || 1) / 2));
    const matches = Number.isFinite(cents) && Math.abs(cents - context.net) <= roundingTolerance;
    return { context, button, eligible, validated, appReady, cents, matches,
      active: eligible && validated && appReady && matches };
  }
  function sync() {
    scheduled = false;
    const s = state(); if (!s) return;
    const setHTML = (id, value) => {
      const el = byId(id);
      if (!el || renderedValues.get(el) === value) return;
      renderedValues.set(el, value);
      // Browsers serialize currency NBSP characters as entities in innerHTML.
      // Compare the desired value before writing to avoid an observer loop.
      if (el.innerHTML !== value) el.innerHTML = value;
    };
    s.button.hidden = !(s.eligible && s.validated);
    s.button.disabled = busy || s.button.dataset.processing === 'true' || !s.active;
    byId('checkout-btn').hidden = s.eligible && s.validated;
    const error = byId('ap-vat-checkout-error');
    if (error) {
      error.hidden = !(s.eligible && s.validated && s.appReady && !s.matches);
      if (!error.hidden && error.textContent !== message) error.textContent = message;
    }
    let netMoney = original['cc-netto-val'];
    if (s.active && s.cents !== s.context.net) {
      netMoney = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: s.context.currency
      }).format(s.cents / 100);
    }
    setHTML('cc-total-val', s.active ? netMoney : original['cc-total-val']);
    setHTML('cc-netto-val', s.active ? netMoney : original['cc-netto-val']);
    setHTML('cc-vat-val', s.active ? byId('cc-vat-val').dataset.zeroMoney : original['cc-vat-val']);
    const taxLabel = byId('cc-vat-val')?.previousElementSibling;
    const label = s.active ? 'VAT (0%)' : original.taxLabel;
    if (taxLabel && taxLabel.textContent !== label) taxLabel.textContent = label;
    const grossRow = byId('cc-gross-val')?.parentElement;
    if (grossRow) grossRow.hidden = s.active;
  }
  function schedule() {
    if (!scheduled) { scheduled = true; queueMicrotask(sync); }
  }
  document.addEventListener('change', schedule);
  document.addEventListener('submit', event => {
    const s = state();
    if (event.target.id !== 'cart' || !s?.eligible || !s.validated) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (s.active) s.button.click();
  }, true);
  // The document capture handler runs before the app's button handler. Await the
  // cart save so the draft includes the selected customer type and company data.
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('#ap-b2b-checkout');
    if (!button || forwarding) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const s = state();
    if (!s?.active || busy || button.dataset.processing === 'true') return;
    busy = true; button.disabled = true;
    try {
      await window.persistCompanyAttributes(false);
      busy = false;
      sync();
      if (!state()?.active || button !== byId('ap-b2b-checkout')) return;
      forwarding = true;
      button.dataset.apB2bForwarding = 'true';
      button.click();
    } catch (error) {
      const box = byId('ap-vat-checkout-error');
      if (box) { box.hidden = false; box.textContent = message; }
    } finally {
      forwarding = false; busy = false;
      delete button.dataset.apB2bForwarding;
    }
  }, true);
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-b2b-enabled', 'data-b2b-price', 'data-b2b-exemption-reason', 'data-validation-hash', 'data-processing']
  });
  sync();
})();
